<nb-card>
  <nb-card-header>
    <nb-icon icon="close-outline" (click)="closeDialog()"></nb-icon>
    ایجاد فضای کاری
  </nb-card-header>
  <nb-card-body>
    <div class="name">
      <span>نام فضای کاری</span>
      <input class="input-name"
             [(ngModel)]="workSpaceName"
             type="text"
             fieldSize="small"
             required
             nbInput>
    </div>
    <div class="info">برای افزودن نقش به فضای کاری، آن‌ها انتخاب کنید.</div>
    <div class="search-input">
      <input
        #role
        (input)="searchRoles(role.value)"
        fullWidth
        id="search-input"
        type="text"
        fieldSize="small"
        placeholder="جستجو"
        nbInput>

      <morva-icons icon="search" class="ms-2"></morva-icons>
    </div>
    <div class="header" *ngIf="filteredRoles.length > 0 && this.roles !== null">
      <div class="name col-5">نام</div>
    </div>
    <hr  *ngIf="filteredRoles.length > 0 && this.roles !== null">
    <div class="header" *ngIf="filteredRoles.length === 0 && this.roles !== null">
      <div class="no-name"></div>
    </div>
    <br  *ngIf="filteredRoles.length === 0 && this.roles !== null">
    <div class="roles">
      <div *ngFor="let role of filteredRoles; last as isLast">
        <div class="table-row me-3">
          <nb-checkbox [checked]="role?.isActive" (change)="changeRoleStatus(role.id)"></nb-checkbox>
          <div class="name">{{ role.name }}</div>
        </div>

        <hr *ngIf="!isLast">
      </div>
      <div class="d-flex justify-content-center align-items-center" *ngIf="filteredRoles.length === 0 && this.roles !== null">
        <p class="no-roles">نقشی به این نام وجود ندارد.</p>
      </div>
    </div>
    <hr class="line-breaker">
    <div class="nb-card-footer">
      <button nbButton (click)="closeDialog()" class="cancle-button">
        انصراف
      </button>
      <button
        nbButton
        [ngClass]="
          workSpaceName ? 'create-button-active' : 'create-button-inactive'
        "
        (click)="createWorkSapce()"
        [disabled]="workSpaceName"
        [nbSpinner]="isUpdating"
      >
        ایجاد
      </button>
    </div>
  </nb-card-body>
</nb-card>
